// *******************************************************************************
// Login and registration form handling
// *******************************************************************************
const deleteSecureCookie = (cookieName) => {
  document.cookie = `${cookieName}=; expires=Thu, 01 Jan 1970 00:00:00 UTC; path=/; secure`;
};
// *******************************************************************************
// Contact form validation
// *******************************************************************************
const handlePaymentResult = (paymentResult, url) => {
  if (paymentResult && paymentResult.result && paymentResult.result.status === 'approved') {
    processItems(document.querySelectorAll('.order-summary .order-summary__body-inner'), 'purchase');
    deleteSecureCookie('cart');
    deleteSecureCookie('info');
    window.location = `${url}true&secret=${localData.secret}`;
  } else {
    document.querySelector('#card-errors').innerHTML = 'Napaka pri plačilu.';
    const failStatus = new FormData();
    failStatus.append('action', 'saveFailureStatus');
    failStatus.append('inputs', JSON.stringify(paymentResult));
    failStatus.append('secret', localData.secret);
    axios.post(localData.apiURL, failStatus, {
      headers: {
        'Content-Type': 'multipart/form-data',
      },
    });
  }
  setTimeout(() => {
    document.querySelector('form button.btn--mod-form__submit').classList.remove('is-loading');
  }, 10000);
};

const isValidCardInputs = () =>
  document.querySelector('#is-valid-card').value === 'true' &&
  document.querySelector('#is-valid-expiry-date').value === 'true' &&
  document.querySelector('#is-valid-cvv').value === 'true';

document.addEventListener('DOMContentLoaded', async () => {
  const checkoutForm = document.getElementById('checkout-form');
  if (checkoutForm) {
    const formAction = document.querySelector('[data-form-action]').value;
    const nonce = await getNonceForAction(formAction);
    const monri = Monri(localData.wspayID, { locale: localData.lang });
    const components = monri.components({ clientSecret: localData.secret });
    const card = components.create('card', { tokenizePan: false });
    card.mount('card-element');
    card.onChange((event) => {
      const displayError = document.getElementById('card-errors');
      displayError.textContent = event.error ? event.error.message : '';
    });
    card.addChangeListener('card_number', (event) => {
      document.querySelector('#is-valid-card').value = event.data.bin > 5;
    });
    card.addChangeListener('expiry_date', (event) => {
      document.querySelector('#is-valid-expiry-date').value = event.data.year && event.data.month ? 'true' : 'false';
    });
    card.addChangeListener('cvv', (event) => {
      document.querySelector('#is-valid-cvv').value = event.valid;
    });
    const axiosAction = (formData) => {
      grecaptcha.ready(() => {
        grecaptcha.execute(localData.captchaSiteKey, { action: formAction }).then((token) => {
          const formDataInput = new FormData();
          formDataInput.append('action', formAction);
          formDataInput.append('nonce', nonce);
          formDataInput.append('inputs', JSON.stringify(formData));
          formDataInput.append('cart', JSON.stringify(getItemsFromCookie()));
          formDataInput.append('lang', localData.lang);
          formDataInput.append('id', localData.id);
          formDataInput.append('token', token);
          formDataInput.append('secret', localData.secret);
          formDataInput.append('secret_price', localData.secret_price);
          axios
            .post(localData.apiURL, formDataInput, {
              headers: {
                'Content-Type': 'multipart/form-data',
              },
            })
            .then(async (response) => {
              if (response.status === 200) {
                const paymentResult = await monri
                  .confirmPayment(card, {
                    fullName: `${formData.name} ${formData.surname}`,
                    phone: formData.telephone,
                    country: 'SI',
                    email: formData.email,
                    orderInfo: JSON.stringify(getItemsFromCookie()),
                    orderNumber: localData.secret,
                    currency: 'EUR',
                  })
                  .then((result) => {
                    if (result.error) {
                      document.getElementById('card-errors').textContent = result.error.message;
                    }
                    return result;
                  });
                await handlePaymentResult(paymentResult, response.data.data.url);
              }
            })
            .catch((err) => {
              console.error(err);
              document.getElementById('card-errors').textContent = err.response.data.data.msg;
              document.querySelector('form button.btn--mod-form__submit').classList.remove('is-loading');
            });
        });
      });
    };

    const fv = FormValidation.formValidation(checkoutForm, {
      locale: 'sl_SI',
      localization: FormValidation.locales.sl_SI,
      fields: {},
      plugins: {
        message: new FormValidation.plugins.Message({
          container: (field, element) => element.closest('.mod-input,.checkbox'),
        }),
        declarative: new FormValidation.plugins.Declarative({
          html5Input: true,
        }),
        trigger: new FormValidation.plugins.Trigger(),
        submitButton: new FormValidation.plugins.SubmitButton(),
      },
    })
      .on('core.element.validated', (e) => {
        // e.element presents the field element
        // e.valid indicates the field is valid or not

        // Get the field value
        if (e.element.hasAttribute('required')) {
          const value = fv.getElementValue(e.field, e.element);
          const container = FormValidation.utils.closest(e.element, '.mod-input,.checkbox');
          FormValidation.utils.classSet(container, {
            'is-validation-failed': value === '' || !e.valid,
          });
        }
      })
      .on('core.form.valid', () => {
        const formData = {};
        checkoutForm.querySelectorAll('input, textarea').forEach((input) => {
          if (input.type === 'checkbox') {
            formData[input.name] = input.checked;
          } else {
            formData[input.name] = input.value.trim();
          }
        });
        if (!document.getElementById('card-errors').innerText.length) {
          if (isValidCardInputs()) {
            document.querySelector('form button.btn--mod-form__submit').classList.add('is-loading');
            axiosAction(formData);
          } else {
            document.querySelector('#card-errors').innerHTML = 'Izpolnite manjkajoče podatke';
          }
        }
      });

    if (document.querySelector('.icon-arrow-right, .icon-close')) {
      document.querySelector('.icon-arrow-right, .icon-close').addEventListener('click', (e) => {
        const code = document.querySelector('#code').value;
        const code_info_box = document.querySelector('.code-info');
        if (code && code_info_box) {
          code_info_box.innerHTML = '';
          const formDataInput = new FormData();
          formDataInput.append('action', 'addRemoveCode');
          formDataInput.append('code', code);
          formDataInput.append('remove', e.target.classList.contains('icon-close'));
          axios.post(localData.apiURL, formDataInput, {
            headers: {
              'Content-Type': 'multipart/form-data',
            },
          })
              .then((response) => {
                if (response.status === 200) {
                  Cookies.set('info', JSON.stringify({
                    name : document.querySelector('#name').value,
                    surname : document.querySelector('#surname').value,
                    telephone : document.querySelector('#telephone').value,
                    email : document.querySelector('#email').value,
                    code : response.data.data.removed ? '' : document.querySelector('#code').value,
                  }), { expires: 14, secure: true });
                  window.location.reload();
                } else {
                  code_info_box.innerHTML = response.data.data.msg;
                }
              })
              .catch((err) => {
                console.error(err);
                code_info_box.innerHTML = err.response.data.data.msg;
              });
        }
      });
    }
  }
});
